










































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import TextInput from '@shared/components/forms/inputs/input/input.vue';
import { POSProductCategory } from '@pos/interfaces/pos-v2';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';

@Component({
  name: 'bpc-pos-adjust-quantity-modal',
  components: {
    'bpc-input': TextInput,
    'bpc-switch': Switch,
    'bpc-entity-select': EntitySelect,
  },
})
export default class PosAdjustQuantityQuantityModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Object })
  readonly productCategory: POSProductCategory;

  public confirmingQuantity: boolean = false;
  public quantitySelected: number = 1;
  public badgeNumber: string = null;
  public manualAccessEvent: boolean = false;
  public selectedRessourceId: any = null;

  onConfirmQuantity() {
    this.confirmingQuantity = true;
    if (this.accessControlActivated && this.manualAccessEvent && !this.selectedRessourceId) {
      this.$bpcMessage.showErrorMessage({
        text: 'global.error.manual_access_event.resource_required',
      });
    } else {
      this.$emit('confirm-quantity', {
        quantity: this.quantitySelected,
        productCategory: this.productCategory,
        manualAccessEvent: this.manualAccessEvent,
        selectedRessourceId: this.selectedRessourceId,
        badgeNumber: this.badgeNumber,
      });
      this.resetModal();
    }
    this.confirmingQuantity = false;
  }

  resetModal() {
    this.quantitySelected = 1;
    this.manualAccessEvent = false;
    this.selectedRessourceId = null;
    this.badgeNumber = null;
  }

  onCloseModal() {
    this.resetModal();
    this.$emit('close-modal');
  }

  get accessControlActivated() {
    return this.$modulesService.hasModuleActivated('access_control');
  }

  get requiredSecondaryBadge(): boolean {
    return this.productCategory?.requiredSecondaryBadge;
  }
}
